<template>
  <b-row v-if="parentPath && path" style="margin-bottom: 5rem" class="geometry-details">
    <b-col>
      <el-tabs type="border-card" tab-click="!isActiveTab" :class="{ 'tab-color': isActiveTab }">
        <el-tab-pane>
          <span slot="label">{{ uniTranslation("S944") }}</span>
          <el-form ref="form-details" label-width="200px" label-position="left" size="small">
            <b-row class="mt-4">
              <b-col md="6">
                <el-form-item :label="uniTranslation('S1464')" :span="24">
                  <el-input v-model="description"></el-input>
                </el-form-item>

                <el-form-item :label="uniTranslation('S176')">
                  <el-select v-model="finVal">
                    <el-option
                      v-for="item in fin"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="uniTranslation('S174')">
                  <el-select v-model="spacingVal">
                    <el-option
                      v-for="item in spacing"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <!-- Tube Spacing -->
                <UnidataEditor :parent-path="path" :name="'.passoTubi'"></UnidataEditor>

                <!-- Rows Spacing -->
                <UnidataEditor
                  :parent-path="path"
                  :name="'.passoRanghi'"
                  class="mb-2"
                ></UnidataEditor>
                <hr />
                <el-form-item :label="uniTranslation('S2016')" class="mt-2">
                  <el-select v-model="tubeShapeVal" @change="handleTubeShape">
                    <el-option
                      v-for="item in tubeShape"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <!-- tube thickness-->
                <UnidataEditor :parent-path="path" :name="'.spessoretubo'"></UnidataEditor>

                <!--  tube external diameter-->
                <UnidataEditor
                  v-show="isCircularTube"
                  :parent-path="path"
                  :name="'.diamEster'"
                ></UnidataEditor>

                <!-- tube width-->
                <UnidataEditor
                  v-show="isRectangularTube"
                  :parent-path="path"
                  :name="'.larghezzaTubo'"
                ></UnidataEditor>

                <!-- tube height-->
                <UnidataEditor
                  v-show="isRectangularTube"
                  :parent-path="path"
                  :name="'.altezzaTubo'"
                  class="mb-2"
                ></UnidataEditor>
                <hr />
                <!-- fin thickness -->
                <UnidataEditor
                  :parent-path="path"
                  :name="'.spessoreAletta'"
                  class="mt-2"
                ></UnidataEditor>

                <!-- fin height -->
                <UnidataEditor :parent-path="path" :name="'.altezzaAletta'"></UnidataEditor>

                <!-- <el-form-item style="float:left" class="mt-2 submit-button">
                                    <el-button type="primary" @click="onSubmit">{{uniTranslation('S1840')}}</el-button>
                                </el-form-item> -->
              </b-col>
              <b-col md="6">
                <canvas id="myCanvas" style="width:100%; border:1px solid #d3d3d3;"></canvas>
                <el-button @click="handleClearCanvas">Clear</el-button>
                <el-form-item :label="uniTranslation('S1312')">
                  <el-switch v-model="isFavorite"></el-switch>
                </el-form-item>
              </b-col>
            </b-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="uniTranslation('S1074')">
          <el-form ref="form-factors" label-width="200px" label-position="left">
            <b-row class="mt-4">
              <b-col md="6">
                <!-- Fin Corr. Factor -->
                <UnidataEditor :parent-path="path" :name="'.fatCorAl'"></UnidataEditor>

                <!-- Coef. Factor Tube Side-->
                <UnidataEditor :parent-path="path" :name="'.fatCoeflattub'"></UnidataEditor>

                <!-- Corr.Factor Friction factor -->
                <UnidataEditor :parent-path="path" :name="'.fatCorrFatAttr'"></UnidataEditor>

                <!-- Friction Factor Air Side -->
                <UnidataEditor :parent-path="path" :name="'.fattoreAttrAria'"></UnidataEditor>

                <!-- Rid./Aum. Factor Surface-->
                <UnidataEditor :parent-path="path" :name="'.fatRidAumSup'"></UnidataEditor>

                <!-- Rid. Area Pass. Tube -->
                <UnidataEditor :parent-path="path" :name="'.ridAreaPassTubo'"></UnidataEditor>

                <!-- Latent air friction factor -->
                <UnidataEditor
                  :parent-path="path"
                  :name="'.fattoreAttrAriaLatente'"
                ></UnidataEditor>

                <!-- <el-form-item :label="uniTranslation('S1574')" class="switch-right">
                                    <el-switch v-model="isDeltaFFactorsTable"></el-switch>
                                </el-form-item> -->
              </b-col>
              <b-col md="6">
                <!-- Slope Fin Corr. Factor -->
                <UnidataEditor :parent-path="path" :name="'.slopeFatCorAl'"></UnidataEditor>

                <!-- Slope Fact. Tube Side Coeff.-->
                <UnidataEditor :parent-path="path" :name="'.slopeFatCoeflattub'"></UnidataEditor>

                <!-- Slope Corr. Factor Friction factor -->
                <UnidataEditor :parent-path="path" :name="'.slopeFatCorrFatAttr'"></UnidataEditor>

                <!-- Slope Fact. Air Friction -->
                <UnidataEditor :parent-path="path" :name="'.slopeFattoreAttrAria'"></UnidataEditor>

                <!-- Tube Inner Surfaces Ratio-->
                <UnidataEditor :parent-path="path" :name="'.rappSuperficiInterne'"></UnidataEditor>

                <!-- Security Factor -->
                <UnidataEditor :parent-path="path" :name="'.securityFactor'"></UnidataEditor>
              </b-col>
            </b-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </b-col>
  </b-row>
</template>

<script>
import { Switch, Form, FormItem, Tabs, TabPane, Select, Option, Input, Button } from "element-ui";
import UnidataEditor from "../unidata/UnidataEditor";
//import AdvancedGeometryFactorsTab from "./AdvancedGeometryFactorsTab";
import { mapGetters } from "vuex";
import jsonHelper from "../../shared/jsonHelper";
export default {
  components: {
    "el-select": Select,
    "el-option": Option,
    "el-tab-pane": TabPane,
    "el-tabs": Tabs,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input,
    "el-button": Button,
    "el-switch": Switch,
    UnidataEditor
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      showFull: false,
      isFavorite: true,
      isDeltaFFactorsTable: false,
      description: "",
      fin: [
        {
          value: 1,
          label: "Integral"
        },
        {
          value: 2,
          label: "Spiroidal"
        }
      ],
      spacing: [
        {
          value: "S",
          label: "Staggered"
        },
        {
          value: "A",
          label: "Aligned"
        }
      ],
      tubeShape: [
        {
          value: 1,
          label: "Circular"
        },
        {
          value: 2,
          label: "Rectangular"
        },
        {
          value: 3,
          label: "Rounded Rectangular"
        }
      ],
      tubeExtDia: null,
      finVal: null,
      spacingVal: "",
      tubeShapeVal: null,
      isRectangularTube: false,
      isCircularTube: false,
      isActiveTab: false,
      canvas: null,
      ctx: null,
      centerX: null,
      centerY: null,
      rowSpacingCenterX: null,
      rowSpacingCenterY: null,
      tubeSpacingCenterX: null,
      tubeSpacingCenterY: null,
      rowSpacing: null,
      tubeSpacing: null,
      unsubscribes: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    description: function(val) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".descrizione",
        value: val
      });
    },
    finVal: function(val) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".alCS",
        value: val
      });
    },
    spacingVal: function(val) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".psq",
        value: val
      });
    },
    tubeShapeVal: function(val) {
      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".formaTubo",
        value: val
      });
    },
    tubeExtDia: function() {
      return jsonHelper.getProperty(this.projects, this.path + ".diamEster");
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    if (this.parentPath && this.localPath)
      this.path = this.parentPath + this.localPath + ".geometry";
    var that = this;
    this.description = jsonHelper.getProperty(that.projects, that.path + ".descrizione");
    this.finVal = jsonHelper.getProperty(that.projects, that.path + ".alCS");
    this.spacingVal = jsonHelper.getProperty(that.projects, that.path + ".psq");
    this.tubeShapeVal = jsonHelper.getProperty(that.projects, that.path + ".formaTubo");

    this.tubeExtDia = jsonHelper.getProperty(that.projects, that.path + ".diamEster");

    this.rowSpacing = jsonHelper.getProperty(that.projects, that.path + ".passoRanghi");

    if (this.rowSpacing != null) {
      this.rowSpacing = this.rowSpacing.output.refValue.value;
    }

    this.tubeSpacing = jsonHelper.getProperty(that.projects, that.path + ".passoTubi");

    if (this.tubeSpacing != null) {
      this.tubeSpacing = this.tubeSpacing.output.refValue.value;
    }

    if (this.tubeExtDia != null) this.tubeExtDia = this.tubeExtDia.output.refValue.value;

    if (this.tubeShapeVal == 1) {
      this.isCircularTube = true;
    } else if (this.tubeShapeVal == 2 || this.tubeShapeVal == 3) {
      this.isRectangularTube == true;
    }
  },
  updated() {
    var canvas = document.getElementById("myCanvas");
    var ctx = canvas.getContext("2d");
    this.centerX = canvas.width / 2;
    this.centerY = canvas.height / 2;
    this.canvas = canvas;
    this.ctx = ctx;
    this.ctx.beginPath();
    this.ctx.arc(this.centerX, this.centerY, this.tubeExtDia, 0, 2 * Math.PI);
    this.ctx.stroke();

    this.rowSpacingCenterX = canvas.width / 2 - this.rowSpacing;
    this.rowSpacingCenterY = canvas.height / 2 - this.tubeSpacing / 2;
    this.ctx.beginPath();
    this.ctx.arc(this.rowSpacingCenterX, this.rowSpacingCenterY, this.tubeExtDia, 0, 2 * Math.PI);
    this.ctx.stroke();

    this.tubeSpacingCenterX = canvas.width / 2 - this.rowSpacing;
    this.tubeSpacingCenterY = canvas.height / 2 + this.tubeSpacing / 2;
    this.ctx.beginPath();
    this.ctx.arc(this.tubeSpacingCenterX, this.tubeSpacingCenterY, this.tubeExtDia, 0, 2 * Math.PI);
    this.ctx.stroke();

    var that = this;
    that.$nextTick(function() {
      that.unsubscribes.push(
        that.$store.subscribe(function(mutation /*, state*/) {
          var path = that.path + ".diamEster";
          if (mutation.type === "changeProjectProperty") {
            if (mutation.payload.path.startsWith(path)) {
              that.tubeExtDia = mutation.payload.value;
              // that.handleClearCanvas();
              that.handleDrawTubeDiamter();
            }
          }
        })
      );
    });

    that.$nextTick(function() {
      that.unsubscribes.push(
        that.$store.subscribe(function(mutation /*, state*/) {
          var path = that.path + ".passoRanghi";
          if (mutation.type === "changeProjectProperty") {
            if (mutation.payload.path.startsWith(path)) {
              that.rowSpacing = mutation.payload.value;
              that.handleSpacing();
            }
          }
        })
      );
    });

    that.$nextTick(function() {
      that.unsubscribes.push(
        that.$store.subscribe(function(mutation /*, state*/) {
          var path = that.path + ".passoTubi";
          if (mutation.type === "changeProjectProperty") {
            if (mutation.payload.path.startsWith(path)) {
              that.tubeSpacing = mutation.payload.value;
              that.handleSpacing();
            }
          }
        })
      );
    });
  },
  methods: {
    handleTubeShape(val) {
      if (val === 2 || val === 3) {
        this.isRectangularTube = true;
        this.isCircularTube = false;
      } else if (val === 1) {
        this.isRectangularTube = false;
        this.isCircularTube = true;
      }
    },
    handleDrawTubeDiamter() {
      this.ctx.beginPath();
      this.ctx.arc(this.centerX, this.centerY, this.tubeExtDia, 0, 2 * Math.PI);
      this.ctx.stroke();
    },
    handleSpacing() {
      this.ctx.beginPath();
      this.ctx.arc(this.centerX, this.centerY, this.tubeExtDia, 0, 2 * Math.PI);
      this.ctx.stroke();

      var canvas = document.getElementById("myCanvas");
      this.rowSpacingCenterX = canvas.width / 2 - this.rowSpacing;
      this.rowSpacingCenterY = canvas.height / 2 - this.tubeSpacing / 2;
      this.ctx.beginPath();
      this.ctx.arc(this.rowSpacingCenterX, this.rowSpacingCenterY, this.tubeExtDia, 0, 2 * Math.PI);
      this.ctx.stroke();


      this.tubeSpacingCenterX = canvas.width / 2 - this.rowSpacing;
      this.tubeSpacingCenterY = canvas.height / 2 + this.tubeSpacing / 2;
      this.ctx.beginPath();
      this.ctx.arc(
        this.tubeSpacingCenterX,
        this.tubeSpacingCenterY,
        this.tubeExtDia,
        0,
        2 * Math.PI
      );
      this.ctx.stroke();
    },
    handleClearCanvas() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }
};
</script>

<style>
.row.geometry-details .el-select {
  display: inline !important;
}

.row.geometry-details .switch-right > div {
  float: right !important;
  margin-left: 0 !important;
}

.row.geometry-details .el-form-item.submit-button > div {
  margin-left: 0 !important;
}

.row.geometry-details .el-form-item {
  margin-bottom: 0;
}

.row.geometry-details .el-input__inner {
  padding: 0 5px;
}

.row.geometry-details .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: white;
}

.row.geometry-details .el-tabs--border-card {
  background: #e7f8fd !important;
}

.row.geometry-details .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #e7f8fd !important;
}

.row.geometry-details .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #01baef;
}

.row.geometry-details .el-tabs__nav-scroll {
  background: #01baef;
}

.row.geometry-details .el-input--small {
  padding-right: 5px;
}
</style>
